import * as React from 'react';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    textAlign: "center",
    backgroundColor: "#ffffff",
    padding: "5px",
    border: "solid 1px #000",
    borderRadius: "5px",
    marginTop: "10px"
  },
}));

export interface Props {
  /** 距離・時間・金額部分のラベル。 */
  label: string | JSX.Element,
}

/** 予約ページのコスト（距離・時間・金額）表示部分のコンポーネント。 */
const Cost: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {/* 赤字で表示する。 */}
      <Typography color='error' component='span'>
        { props.label }
      </Typography>
    </div>
  );
}

export default Cost;
